import {IS_NORMING_VARIANT} from 'constants/index';

const TEST_IDS = {
	WorkingMemory: 0,
	RapidNaming: 3,
	OneMinute: 4,
	Spoonerism: 5,
	LetterKnowledge: 6,
	PhonemeIsolation: 7,
	PhonemeDeletion: 8,
	WordDictation: 9,
	SentenceMemory:10,
	NonwordRepetition:13,
};

const normingBhg = {
	1: 'LetterKnowledge',
	2: 'PhonemeIsolation',
	3: 'WorkingMemory',
	4: 'RapidNaming',
	5: 'TestComplete',
};
const norming123 = {
	1: 'LetterKnowledge',
	2: 'PhonemeIsolation',
	3: 'WorkingMemory',
	4: 'RapidNaming',
	5: 'PhonemeDeletion',
	6: 'OneMinute',
	7: 'WordDictation',
	8: 'TestComplete',
};
const norming4567 = {
	1: 'PhonemeIsolation',
	2: 'WorkingMemory',
	3: 'RapidNaming',
	4: 'PhonemeDeletion',
	5: 'OneMinute',
	6: 'WordDictation',
	7: 'TestComplete',
};
const normingYouthAdult = {
	1: 'WorkingMemory',
	2: 'RapidNaming',
	3: 'OneMinute',
	4: 'Spoonerism',
	5:	'SentenceMemory',
	6:	'NonwordRepetition',
	7: 'TestComplete',
};
const youthAndAdult = {
	1: 'WorkingMemory',
	2: 'RapidNaming',
	3: 'OneMinute',
	4: 'Spoonerism',
	5: 'SentenceMemory',
	6:	'NonwordRepetition',
	7: 'TestComplete',
};
const grade0And1 = {
	1: 'LetterKnowledge',
	2: 'PhonemeIsolation',
	3: 'WorkingMemory',
	4: 'RapidNaming',
	5: 'TestComplete',
};

const grade2 = {
	1: 'WorkingMemory',
	2: 'RapidNaming',
	3: 'PhonemeDeletion',
	4: 'OneMinute',
	5: 'TestComplete',
};

const grade34567 = {
	1: 'WorkingMemory',
	2: 'RapidNaming',
	3: 'PhonemeDeletion',
	4: 'OneMinute',
	5: 'WordDictation',
	6: 'TestComplete',
};

const dysmateChildGrade0and1 = {
	1: 'LetterKnowledge',
	2: 'PhonemeIsolation',
	3: 'WorkingMemory',
	4: 'RapidNaming',
	5: 'TestComplete',
};
const dysmateChildGrade234567 = {
	1: 'WorkingMemory',
	2: 'RapidNaming',
	3: 'PhonemeDeletion',
	4: 'OneMinute',
	5: 'SentenceMemory',
	6:	'NonwordRepetition',
	7: 'TestComplete',
};

const dysmateChildGrade67 = {
	1: 'WorkingMemory',
	2: 'RapidNaming',
	3: 'PhonemeDeletion',
	4: 'OneMinute',
	5: 'SentenceMemory',
	6: 'Spoonerism',
	7: 'NonwordRepetition',
	8: 'TestComplete',
};

const testsPerGrade = {
	0: grade0And1,
	1: grade0And1,
	2: grade2,
	3: grade34567,
	4: grade34567,
	5: grade34567,
	6: grade34567,
	7: grade34567,
	8: youthAndAdult,
	9: youthAndAdult,
	10: youthAndAdult,
	studiespesialisering: youthAndAdult,
	yrkesfag: youthAndAdult,
	bachelor: youthAndAdult,
	master: youthAndAdult,
	phd: youthAndAdult,
	other: youthAndAdult,
};
const normingTestsPerGrade = {
	0: normingBhg,
	1: norming123,
	2: norming123,
	3: norming123,
	4: norming4567,
	5: norming4567,
	6: norming4567,
	7: norming4567,
	8: normingYouthAdult,
	9: normingYouthAdult,
	10: normingYouthAdult,
	studiespesialisering: normingYouthAdult,
	yrkesfag: normingYouthAdult,
	bachelor: normingYouthAdult,
	master: normingYouthAdult,
	phd: normingYouthAdult,
	other: normingYouthAdult,
};
const dysmateChild2TestsPerGrade = {
	0: dysmateChildGrade0and1,
	1: dysmateChildGrade0and1,
	2: dysmateChildGrade234567,
	3: dysmateChildGrade234567,
	4: dysmateChildGrade234567,
	5: dysmateChildGrade234567,
	6: dysmateChildGrade67,
	7: dysmateChildGrade67,
	8: normingYouthAdult,
	9: normingYouthAdult,
	10: normingYouthAdult,
	studiespesialisering: normingYouthAdult,
	yrkesfag: normingYouthAdult,
	bachelor: normingYouthAdult,
	master: normingYouthAdult,
	phd: normingYouthAdult,
	other: normingYouthAdult,
};

export const testNumbers = youthAndAdult;
export const getNameFromNumber = (testNumber, age, testKeyType) => {
	return getTestsForClass(age, testKeyType)[testNumber];
};

export const getTestsForClass = (age, testKeyType) => {
	if (testKeyType === 'youth-followup') {
		if (normingTestsPerGrade[age]) {
			return normingTestsPerGrade[age];
		} else throw new Error('Invalid grade given');
	} else if (testKeyType === 'adult-followup') {
		return normingTestsPerGrade[8];
	} else if (testKeyType === 'child-followup') {
		if (dysmateChild2TestsPerGrade[age]) {
			return dysmateChild2TestsPerGrade[age];
		} else throw new Error('Invalid grade given');
	} else {
		if (testsPerGrade[age]) {
			return testsPerGrade[age];
		} else throw new Error('Invalid grade given');
	}
};

export const getTestIDFromName = (testNumber, age, testKeyType) => {
	const name = getTestsForClass(age, testKeyType)[testNumber];
	return TEST_IDS[name];
};

export const tryGetTestsForClass = (age, testKeyType) => {
  // accept 0 as valid, but reject null/undefined/NaN
  var hasValidAge = (age === 0) || (typeof age === 'number' && !isNaN(age)) || (typeof age === 'string' && age.length > 0);
  if (!hasValidAge) return null;

 
  if (testKeyType === 'youth-followup') {
    return normingTestsPerGrade[age] || null;
  } else if (testKeyType === 'adult-followup') {
    return normingTestsPerGrade[8] || null;
  } else if (testKeyType === 'child-followup') {
    return dysmateChild2TestsPerGrade[age] || null;
  } else {
    return testsPerGrade[age] || null;
  }
};
export const tryGetNameFromNumber = (testNumber, age, testKeyType) => {
  var plan = tryGetTestsForClass(age, testKeyType);
  if (!plan) return null;
  return plan[testNumber] || null;
};
